module.exports = __webpack_public_path__ + "img/av_owl.711727bb.png";